import { render, staticRenderFns } from "./base-field-time.vue?vue&type=template&id=19ef3434&"
import script from "./base-field-time.vue?vue&type=script&lang=js&"
export * from "./base-field-time.vue?vue&type=script&lang=js&"
import style0 from "./base-field-time.vue?vue&type=style&index=0&id=19ef3434&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports